const helvetica = 'HelveticaNeue, sans-serif'
const merriweather =
  'Merriweather, merriweather, merriweather-1, merriweather-2, serif'
const noe =
  'Noe Display, proxima-nova, proxima-nova-1, proxima-nova-2, Open Sans, Gill Sans, Corbel, Arial, sans-serif'
const proxima =
  'Proxima Nova, proxima-nova, proxima-nova-1, proxima-nova-2, Open Sans, Gill Sans, Corbel, Arial, sans-serif'
const proximaBlack = 'ProximaNova-Black, Arial-Black, sans-serif'
const sansSerif =
  '"proxima-nova-1", "proxima-nova-2", "proxima-nova", "Proxima Nova", Helvetica, Arial, sans-serif'
const sourceCode =
  'Source Code Pro, source-code-pro, source-code-pro-1, source-code-pro-2, Monaco, Courier New, Courier, monospace'

export const fonts = {
  helvetica,
  merriweather,
  noe,
  proxima,
  proximaBlack,
  sansSerif,
  sourceCode,
} as const
